import { ObservationSummaryDto } from '../../coaching-base/general';
import { ObjectDateTransformer } from '../../coaching-insight/coaching-insight.model';
import { ModelTransformer } from '../../common/common.model';

export class ObservationSummaryDtoTransformer
    implements ModelTransformer<ObservationSummaryDto, ObservationSummaryDto>
{
    transform(model: ObservationSummaryDto): ObservationSummaryDto {
        const dateTransformer =
            new ObjectDateTransformer<ObservationSummaryDto>({
                event: {
                    sessionDate: null,
                    createdOn: null,
                    updatedOn: null,
                    startTime: null,
                    endTime: null,
                },
                focusContainers: {
                    interactions: {
                        interactionDateTime: null,
                        linkedOn: null,
                    },
                },
            });
        return dateTransformer.transform(model);
    }
}
